/* eslint-disable max-len */
import ScrollStory from '@bbc/news-vj-scrollstory';
import wrapper from 'wrapper';

class ScrollyTracker {
    constructor(container, { sceneSelector }) {
        const opts = {
            container,
            scenes: container.querySelectorAll(sceneSelector),
            guideline: 99, // bottom of viewport
            // debug: true
        };

        if (!opts.container.innerHTML) throw Error('`.scrolly-tracker` container not found.');

        if (!opts.scenes.length) throw Error(`'${sceneSelector}' elems not found.`);

        return this.init(opts);
    }

    init(opts) {
        return new ScrollStory({
            container: opts.container,
            scenes: opts.scenes,
            guideline: opts.guideline,
            enter: (d) => {
                wrapper.trackUserAction('Scroll to profile', `${d.index + 1}`);
            },
        });
    }
}

export default ScrollyTracker;
